<template lang="html">
	<div class="invoice-box clearfix" @click="">
		<div class="name-box f-l">
			<div class="clearfix date-box">
				<div class="date f-l">
					{{ moment(invoice.ipf_application_date).format('Do') }}/
				</div>
				<div class="date f-l">
					{{ moment(invoice.ipf_application_date).format('MMM') }}/
				</div>
				<div class="date f-l">
					{{ moment(invoice.ipf_application_date).format('YYYY') }}
				</div>
			</div>
			<div class="name">
				{{ invoice.name }} - <b>{{ invoice.bank_code }}</b>
			</div>
			<div class="insurance">{{ invoice.loan_ref.toUpperCase() }}</div>
			<div class="bank">{{ invoice.invoice_status }}</div>
			<div class="txt"></div>
		</div>
		<div class="price-box f-r">
			<div class="txt">Total</div>
			<div class="price tx-blue" v-if="invoice.loan_amount">
				{{ utils.numberWithCommas(invoice.loan_amount).split('.')[0]
				}}<span class="point"
					>.{{
						(Math.round(invoice.loan_amount * 100) / 100)
							.toString()
							.split('.')[1] || '00'
					}}</span
				>
			</div>
			<div class="price tx-blue" v-else>
				0<span class="point">.00</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		invoice: {
			default: function () {
				return {
					created_date: '',
					loan_status: '',
					created_date: '',
				};
			},
		},
	},
	data() {
		return {
			utils,
			moment,
		};
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.invoice {
	margin: 30px 0;
}

.invoice-box {
	cursor: pointer;
	border-radius: 4px;
	border: solid 1px #e6eaee;
	background: var(--white);
	padding: 20px 15px;
	margin: 10px 0;

	.name {
		color: @grey;
		font-size: 13px;
		font-weight: 600;
	}
	.date-box {
		margin: -1px 15px 0 0;

		.month,
		.year {
			color: @grey;
			font-size: 11px;
			font-weight: 600;
			line-height: 10px;
		}

		.date {
			font-size: 14px;
			font-family: var(--font-bold);
			color: var(--text-color);
			margin: 2px 0;
		}
	}

	.name-box {
		.insurance {
			font-size: 16px;
			color: var(--text-color);
			font-family: var(--font-bold);
			line-height: 15px;
		}

		.bank {
			font-weight: 600;
			font-size: 11px;
			color: var(--ne-yellow);
			margin: 0 0 4px 0;
		}

		.txt {
			font-weight: 600;
			color: @grey;
			font-size: 13px;
		}
	}

	.categories {
		margin: 10px 0 0 0;

		.category:last-child {
			.circle {
				display: none;
			}
		}

		.name {
			font-weight: 600;
			color: #9c7bfc;
			font-size: 13px;
		}

		.circle {
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background: #9c7bfc;
			margin: 7px 10px 0 10px;
		}
	}

	.price-box {
		text-align: right;

		.price {
			font-size: 16px;
			line-height: 15px;
			font-family: var(--font-bold);
			margin: 5px 0 0 0;

			.point {
				font-size: 11px;
			}
		}

		.txt {
			font-weight: 600;
			font-size: 13px;
			color: @grey;
		}
	}
}
</style>
